import { Redirect, Route } from "react-router-dom"

export default function PrivateRoute ({children, ...rest}) {
  return (
    <Route 
      {...rest}
      render={() => {
        if (localStorage.getItem('token')){
          return children
        } else {
          return <Redirect to="/login" />
        }
      }}
    />
  )

}